import React from 'react';
import logo from '../assets/amfy-logo.svg';

/**
 * Логотип AMFY. Исходный SVG белый, поэтому показываем его на фирменной
 * бирюзовой подложке (как в шапке промо-сайта amfy.app).
 */
const AmfyLogo = ({height = 40, style}) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 24,
                ...style,
            }}
        >
            <div
                style={{
                    background: '#00817C',
                    padding: '12px 22px',
                    borderRadius: 12,
                    display: 'inline-flex',
                }}
            >
                <img src={logo} alt="AMFY" style={{height, display: 'block'}}/>
            </div>
        </div>
    );
};

export default AmfyLogo;
